import React from 'react'
import { YStack } from 'tamagui'

import { Paragraph } from '@newComponents/Text'
import { getStaticImageUrl } from '@data/config/imageUrl'

export const DocScreenshot = ({
  src,
  alt,
  caption,
}: {
  src: string
  alt: string
  caption?: string
}) => (
  <YStack
    tag='figure'
    alignItems='center'
    gap='$2'
    marginHorizontal='auto'
    maxWidth={390}
    width='100%'
  >
    <YStack
      borderRadius='$4'
      borderWidth={1}
      borderColor='$borderColor'
      overflow='hidden'
      width='100%'
    >
      {/* Use an HTML img tag — docs are web-only and this auto-sizes to the image's natural dimensions */}
      <img
        src={getStaticImageUrl(src)}
        alt={alt}
        style={{ width: '100%', height: 'auto', display: 'block' }}
      />
    </YStack>
    {caption ? (
      <Paragraph
        tag='figcaption'
        size='$4'
        color='$colorMuted'
        textAlign='center'
      >
        {caption}
      </Paragraph>
    ) : null}
  </YStack>
)
